const initialState = {
  visible: {},
}

export default initialState
